/*
// Документація по роботі у шаблоні: 
// Документація слайдера: https://swiperjs.com/
// Сніппет(HTML): swiper
// */

// Підключаємо слайдер Swiper з node_modules
// При необхідності підключаємо додаткові модулі слайдера, вказуючи їх у {} через кому
// Приклад: { Navigation, Autoplay }
import Swiper from "swiper";
import { Grid, Navigation, Pagination, Scrollbar, Mousewheel } from "swiper/modules";
/*
Основні модулі слайдера:
Navigation, Pagination, Autoplay, 
EffectFade, Lazy, Manipulation
Детальніше дивись https://swiperjs.com/
*/

// Стилі Swiper
// Базові стилі
// import "../../scss/base/swiper.scss";
// Повний набір стилів з scss/libs/swiper.scss
import "../../scss/libs/swiper.scss";
// Повний набір стилів з node_modules
// import 'swiper/css';

// Ініціалізація слайдерів
function initSliders() {

  const mobileSlidesCount = 1.2;

  if (window.innerWidth < 767) {

    const reviews = document.querySelectorAll(".s-reviews__wr");
    if (reviews.length > 0) {
      reviews.forEach((slider, index) => {
        // Елемент скролбара
        slider.querySelector('.s-reviews__grid').classList.add('swiper-wrapper');

        const partnersScrollbarEl = slider.closest('.s-reviews').querySelector('.slider-controlls__scrollbar');

        const swiper = new Swiper(slider, {
          modules: [Scrollbar, Mousewheel],
          slidesPerView: mobileSlidesCount,
          speed: 800,
          loop: false,
          touchReleaseOnEdges: true,
          passiveListeners: true,
          touchStartPreventDefault: false,
          loop: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 50 // збільшує "шаг" на тачпаді
          },

          // Скроллбар
          scrollbar: {
            el: partnersScrollbarEl,
            draggable: true,
          },

          // Брейкпоінти
          breakpoints: {
            550: {
              slidesPerView: 2.1,
            },
          },
        });
      });
    }
  }


  const teamSlider = document.querySelectorAll(".team-slider__slider");
  if (teamSlider.length > 0) {
    teamSlider.forEach((slider, index) => {
      // Елемент скролбара
      const partnersScrollbarEl = slider.closest('.team-slider').querySelector('.slider-controlls__scrollbar');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: 2,
        speed: 800,
        loop: false,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: partnersScrollbarEl,
          draggable: true,
        },

        // Брейкпоінти
        breakpoints: {
          620: {
            slidesPerView: 2,
          },
          860: {
            slidesPerView: 3,
          },
          1150: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  const partnersSlider = document.querySelectorAll(".partners__slider");
  if (partnersSlider.length > 0) {
    partnersSlider.forEach((slider, index) => {
      // Елемент скролбара
      const partnersScrollbarEl = slider.closest('.partners').querySelector('.slider-controlls__scrollbar');
      // Контроли
      const partnersControlsEl = slider.closest('.partners').querySelector('.slider-controlls');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: 2,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: partnersScrollbarEl,
          draggable: true,
        },

        // Брейкпоінти
        breakpoints: {
          768: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 6,
          },
          1124: {
            slidesPerView: 8,
          },
        },

        // Події
        on: {
          init: function () {
            // Перевіряємо кількість слайдів
            if (this.slides.length <= this.params.slidesPerView) {
              if (partnersScrollbarEl) partnersScrollbarEl.style.display = 'none';
              if (partnersControlsEl) partnersControlsEl.style.display = 'none';
            }
          }
        }
      });
    });
  }

  // tpbs__row
  const tpbs34 = document.querySelectorAll(".tpbs-3-4");
  if (tpbs34.length > 0) {
    tpbs34.forEach((slider, index) => {
      const tpbsScrollbarEl = slider.closest('.tpbs').querySelector('.slider-controlls__scrollbar');
      const tpbsControlsEl = slider.closest('.tpbs').querySelector('.slider-controlls');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: 1,
        speed: 800,
        loop: false,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: tpbsScrollbarEl,
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1124: {
            slidesPerView: 3.4,
          },
        },

        // Події
        on: {
          init: function () {
            // Перевіряємо кількість слайдів
            if (this.slides.length <= this.params.slidesPerView) {
              if (tpbsScrollbarEl) tpbsScrollbarEl.style.display = 'none';
              if (tpbsControlsEl) tpbsControlsEl.style.display = 'none';
            }
          }
        }
      });
    });
  }

  // tpbs__row
  const tpbs3 = document.querySelectorAll(".tpbs-3");
  if (tpbs3.length > 0) {
    tpbs3.forEach((slider, index) => {
      const tpbsScrollbarEl = slider.closest('.tpbs').querySelector('.slider-controlls__scrollbar');
      const tpbsControlsEl = slider.closest('.tpbs').querySelector('.slider-controlls');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: mobileSlidesCount,
        speed: 800,
        loop: false,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: tpbsScrollbarEl,
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
        },
        // Події
        on: {
          init: function () {
            // Перевіряємо кількість слайдів
            if (this.slides.length <= this.params.slidesPerView) {
              if (tpbsScrollbarEl) tpbsScrollbarEl.style.display = 'none';
              if (tpbsControlsEl) tpbsControlsEl.style.display = 'none';
            }

          }
        }
      });
    });
  }

  // case-list__cards
  const clc4 = document.querySelectorAll(".case-list__cards--4");
  if (clc4.length > 0) {
    clc4.forEach((slider, index) => {

      const clc4sScrollbarEl = slider.closest('.case-list__cards').querySelector('.slider-controlls__scrollbar');
      const clc4ControlsEl = slider.closest('.case-list__cards').querySelector('.slider-controlls');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: 1,
        speed: 800,
        loop: false,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: clc4sScrollbarEl,
          draggable: true,
        },

        // Брейкпоінти
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1124: {
            slidesPerView: 4,
          },
        },

        // Події
        on: {
          init: function () {
            // Перевіряємо кількість слайдів
            if (this.slides.length <= this.params.slidesPerView) {
              if (clc4sScrollbarEl) clc4sScrollbarEl.style.display = 'none';
              if (clc4ControlsEl) clc4ControlsEl.style.display = 'none';
            }

          }
        }
      });
    });
  }

  // case-list__cards
  const slider25 = document.querySelectorAll(".slider25__slider");
  if (slider25.length > 0) {
    slider25.forEach((slider, index) => {

      const slider25ScrollbarEl = slider.closest('.slider25__box').querySelector('.slider-controlls__scrollbar');
      const slider25ControlsEl = slider.closest('.slider25__box').querySelector('.slider-controlls');

      const swiper = new Swiper(slider, {
        modules: [Scrollbar, Mousewheel],
        slidesPerView: 1,
        speed: 800,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchStartPreventDefault: false,
        loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 50 // збільшує "шаг" на тачпаді
        },

        // Скроллбар
        scrollbar: {
          el: slider25ScrollbarEl,
          draggable: true,
        },

        // Брейкпоінти
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1124: {
            slidesPerView: 2.5,
          },
        },

      });
    });
  }



  if (window.innerWidth < 768) {
    // tpbs__row
    const masmediaSlider = document.querySelectorAll(".masmedia__slider");

    const masmediaGrid = document.querySelectorAll(".masmedia__grid");

    masmediaGrid.forEach((el) => {
      el.classList.add('swiper-wrapper');
    });

    if (masmediaSlider.length > 0) {
      masmediaSlider.forEach((slider, index) => {
        const masmediaScrollbarEl = slider.closest('.masmedia').querySelector('.slider-controlls__scrollbar');
        const masmediaControlsEl = slider.closest('.masmedia').querySelector('.slider-controlls');

        const swiper = new Swiper(slider, {
          modules: [Scrollbar, Mousewheel],
          slidesPerView: mobileSlidesCount,
          speed: 800,
          loop: false,
          touchReleaseOnEdges: true,
          passiveListeners: true,
          touchStartPreventDefault: false,
          loop: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 50 // збільшує "шаг" на тачпаді
          },

          // Скроллбар
          scrollbar: {
            el: masmediaScrollbarEl,
            draggable: true,
          },

          // Події
          on: {}
        });
      });
    }

  }

  if (window.innerWidth < 1119) {
    const CLS = document.querySelectorAll(".case-listing-slider");
    if (CLS.length > 0) {
      CLS.forEach((slider, index) => {

        const CLSScrollbarEl = slider.closest('.case-list__cards').querySelector('.slider-controlls__scrollbar');
        const CLSControlsEl = slider.closest('.case-list__cards').querySelector('.slider-controlls');

        const swiper = new Swiper(slider, {
          modules: [Scrollbar, Mousewheel],
          slidesPerView: mobileSlidesCount,
          speed: 800,
          loop: false,
          touchReleaseOnEdges: true,
          passiveListeners: true,
          touchStartPreventDefault: false,
          loop: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 50 // збільшує "шаг" на тачпаді
          },

          // Скроллбар
          scrollbar: {
            el: CLSScrollbarEl,
            draggable: true,
          },

          // Брейкпоінти
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1124: {
              slidesPerView: 4,
            },
          },

          // Події
          on: {
            init: function () {
              // Перевіряємо кількість слайдів
              if (this.slides.length <= this.params.slidesPerView) {
                if (CLSScrollbarEl) CLSScrollbarEl.style.display = 'none';
                if (CLSControlsEl) CLSControlsEl.style.display = 'none';
              }

            }
          }
        });
      });
    }
  }



  if (window.innerWidth < 1030) {


    const blogListSliders = document.querySelectorAll(".blog-list-slider");

    if (blogListSliders.length > 0) {
      blogListSliders.forEach((slider, index) => {
        const scrollbarEl = slider.closest('.blog-list__cards').querySelector('.slider-controlls');

        new Swiper(slider, {
          modules: [Scrollbar],
          slidesPerView: 1,
          freeMode: true,
          touchReleaseOnEdges: true,
          passiveListeners: true,
          touchRatio: 1,

          scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },

          // Breakpoints
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },

          // Events
          on: {
            init: function () {

            }
          },
        });
      });
    }
  }
  const caseListSliders = document.querySelectorAll(".case-list-slider");

  if (caseListSliders.length > 0) {
    caseListSliders.forEach((slider, index) => {
      const scrollbarEl = slider.querySelector('.slider-scrollbar');

      new Swiper(slider, {
        modules: [Scrollbar],
        slidesPerView: 1,
        spaceBetween: 20,
        freeMode: true,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchRatio: 1,

        scrollbar: {
          el: scrollbarEl,
          draggable: true,
        },

        // Breakpoints
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1120: {
            slidesPerView: 0,
          },
        },

        // Events
        on: {
          init: function () {

          }
        },
      });
    });
  }
}
// Скролл на базі слайдера (за класом swiper scroll для оболонки слайдера)
function initSlidersScroll() {
  let sliderScrollItems = document.querySelectorAll(".swiper_scroll");
  if (sliderScrollItems.length > 0) {
    for (let index = 0; index < sliderScrollItems.length; index++) {
      const sliderScrollItem = sliderScrollItems[index];
      const sliderScrollBar =
        sliderScrollItem.querySelector(".swiper-scrollbar");
      const sliderScroll = new Swiper(sliderScrollItem, {
        observer: true,
        observeParents: true,
        direction: "vertical",
        slidesPerView: "auto",
        freeMode: true,
        touchReleaseOnEdges: true,
        passiveListeners: true,
        touchRatio: 1,

        freeMode: {
          enabled: true,
        },
        scrollbar: {
          el: sliderScrollBar,
          draggable: true,
          snapOnRelease: false,
        },
        mousewheel: {
          releaseOnEdges: true,
        },
      });
      sliderScroll.scrollbar.updateSize();
    }
  }
}

window.addEventListener("load", function (e) {
  initSliders();
});



